import { takeEvery } from 'redux-saga'

import actions from 'actions'
import {
  loadEventTypes,
  loadSetupform,
  deleteSetupform,
  updateVenueSearchResults,
  updateSetupformBasicDetails,
  updateSetupformAdvancedDetails,
  addNewVoucher,
  editVoucher,
  deleteVoucher,
  copyVoucher,
  updateSetupformVouchers,
  submitSetupformSaga,
  uploadImageSaga,
  deleteImageSaga,
  setupformLoadSuccessSaga,
  setAsNoVenue,
} from './setupform-sagas'

export function* watchEventTypesLoad() {
  yield* takeEvery(actions.SETUPFORM_LOAD_EVENT_TYPES, loadEventTypes)
}

export function* watchSetupformLoad() {
  yield* takeEvery(actions.SETUPFORM_LOAD, loadSetupform)
}

export function* watchSetupformLoadSuccess() {
  yield* takeEvery(actions.ENTITIES_SETUPFORM.SUCCESS, setupformLoadSuccessSaga)
}

export function* watchSetupformDelete() {
  yield* takeEvery(actions.SETUPFORM_DELETE, deleteSetupform)
}

export function* watchSetupformUpdateBasic() {
  yield* takeEvery(actions.SETUPFORM_UPDATE_BASIC, updateSetupformBasicDetails)
}

export function* watchSetupformUpdateAdvanced() {
  yield* takeEvery(actions.SETUPFORM_UPDATE_ADVANCED, updateSetupformAdvancedDetails)
}

export function* watchSetupformAddNewVoucher() {
  yield* takeEvery(actions.SETUPFORM_ADD_NEW_VOUCHER, addNewVoucher)
}

export function* watchSetupformAddNewVoucherApiSuccess() {
  yield* takeEvery(actions.SETUPFORM_BULK_UPDATE_INSTANCE_GROUPS_API.SUCCESS, updateSetupformVouchers)
}

export function* watchSetupformEditVoucher() {
  yield* takeEvery(actions.SETUPFORM_EDIT_VOUCHER, editVoucher)
}

export function* watchSetupformStartDeletingVoucher() {
  yield* takeEvery(actions.SETUPFORM_START_DELETING_VOUCHER, deleteVoucher)
}

export function* watchSetupformStartCopyingVoucher() {
  yield* takeEvery(actions.SETUPFORM_START_COPYING_VOUCHER, copyVoucher)
}

export function* watchSetupformSubmit() {
  yield* takeEvery(actions.SETUPFORM_SUBMIT, submitSetupformSaga)
}

export function* watchUpdateVenueSearchResults() {
  yield* takeEvery(actions.SETUPFORM_UPDATE_VENUE_SEARCH_RESULTS, updateVenueSearchResults)
}

export function* watchSetupformSetAsNoVenue() {
  yield* takeEvery(actions.SETUPFORM_SET_AS_NO_VENUE, setAsNoVenue)
}

export function* watchCropperSave() {
  yield* takeEvery(actions.CROPPER_SAVE, uploadImageSaga)
}

export function* watchCropperReset() {
  yield* takeEvery(actions.CROPPER_RESET, deleteImageSaga)
}



/** WEBPACK FOOTER **
 ** ./src/sagas/setupform/setupform-watchers.js
 **/